import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import lmsRestrukturisasiService from "services/lms/LMSRestrukturisasiService";

export const initialState = {
    isLoading: false,
    isSuccess: false,
    isError: false,
    message: "",
    total: 0,

    loans: [],
    pengajuanResult: null,
};

export const fetchRestrukturisasiLoans = createAsyncThunk(
    'LMSRestrukturisasi/fetchLoans',
    async (payload, thunkAPI) => {
        try {
            const response = await lmsRestrukturisasiService.getLoans(payload);
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const submitPengajuanRestrukturisasi = createAsyncThunk(
    'LMSRestrukturisasi/submitPengajuan',
    async (payload, thunkAPI) => {
        try {
            return await lmsRestrukturisasiService.createPengajuan(payload);
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    }
);

const restrukturisasiSlice = createSlice({
    name: 'LMSRestrukturisasi',
    initialState,
    reducers: {
        resetRestrukturisasiState: (state) => {
            state.isSuccess = false;
            state.isError = false;
            state.message = '';
            state.pengajuanResult = null;
        }
    },
    extraReducers: (builder) => {
        builder
            /* LIST LOANS */
            .addCase(fetchRestrukturisasiLoans.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchRestrukturisasiLoans.fulfilled, (state, action) => {
                state.isLoading = false;
                state.loans = action.payload.data;
                state.total = action.payload.count;
            })
            .addCase(fetchRestrukturisasiLoans.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })

            /* PENGAJUAN */
            .addCase(submitPengajuanRestrukturisasi.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(submitPengajuanRestrukturisasi.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.pengajuanResult = action.payload;
            })
            .addCase(submitPengajuanRestrukturisasi.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            });
    }
});

export const { resetRestrukturisasiState } = restrukturisasiSlice.actions;

export default restrukturisasiSlice.reducer;
